/**
 * @module interface
 */
export interface V2TimReceiveMessageOptInfo {
    c2CReceiveMessageOpt?: number;
    userID: string;
}
